import UeberUns from 'src/pages/UeberUns/UeberUns'
import { getAboutPageStaticProps } from 'src/pageBuilder/sitePageBuilder'

export default UeberUns

export const getStaticProps = getAboutPageStaticProps
